/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default [
  // {
  //   url: '/dashboard/kinerja',
  //   name: 'Kinerja Laperon',
  //   icon: 'HomeIcon'
  // },
  {
    url: '/mpp',
    name: 'Statistik MPP',
    icon: 'PieChartIcon'
  },
  {
    url: '/skm',
    name: 'Statistik SKM',
    icon: 'PieChartIcon'
  },
  {
    url: '/laperon',
    name: 'Statistik LAPERON',
    icon: 'PieChartIcon'
  },
  {
    url: '/siposs',
    name: 'Statistik SIPOSS',
    icon: 'PieChartIcon'
  },
  {
    url: '/invesment-and-retribution',
    name: 'Realisasi Investasi & Retribusi',
    icon: 'DollarSignIcon'
  },
  {
    url: '/laperon-archive',
    name: 'Informasi Berkas',
    icon: 'ArchiveIcon',
    i18n: 'laperon-archive',
    slug: 'laperon-archive',
    show: true,
    tagColor: 'primary',
    submenu: [
      {
        url: '/laperon-archive',
        name: 'Berkas LAPERON',
        icon: 'FileIcon',
        i18n: 'care',
        slug: 'care',
        show: true,
      },
      {
        url: '/laperon-pkkpr-archive',
        name: 'Berkas LAPERON PKKPR',
        icon: 'FileIcon',
        i18n: 'care-info',
        slug: 'care-info',
        show: true,
      },
    ]
  },
  // {
  //   url: '/archive',
  //   name: 'Informasi Berkas LAPERON',
  //   icon: 'ArchiveIcon'
  // },
  // {
  //   url: '/retribution',
  //   name: '',
  //   icon: 'LogOutIcon'
  // },
  // {
  //   url: '/consultation',
  //   name: 'Informasi Konsultasi',
  //   icon: 'BriefcaseIcon'
  // },
  // {
  //   url: '/laporan',
  //   name: 'Laporan',
  //   icon: 'FileTextIcon'
  // }
]
